// extracted by mini-css-extract-plugin
export default {"TruncatedString":"TruncatedString_TruncatedString__aeF1x","notWrapped":"TruncatedString_notWrapped__GdQBy","wrapped":"TruncatedString_wrapped__MxNlT"};